<template>
  <footer class="page-footer">
    <div class="footer-inner">
      <div class="social-icons">
        <button type="button" class="social-link" aria-label="Instagram" @click="openInstagram">
          <i class="fab fa-instagram"></i>
        </button>
        <button type="button" class="social-link" aria-label="Discord" @click="goSupport">
          <i class="fab fa-discord"></i>
        </button>
      </div>
    </div>
  </footer>
  
</template>

<script>
export default {
  name: 'Footer',
  methods: {
    openInstagram() {
      window.open('https://www.instagram.com/zimatrading/', '_blank', 'noopener');
    },
    goSupport() {
      this.$router.push('/support');
    },
  },
};
</script>

<style scoped>
.page-footer {
  width: 100%;
  padding: 28px 20px 36px;
  background: transparent;
}

.footer-inner {
  max-width: 1200px;
  margin: 0 auto;
  padding-top: 8px;
}

.social-icons {
  display: inline-flex;
  gap: 10px;
  align-items: center;
}

.social-link {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 999px;
  background: transparent;
  font-size: 1.2rem;
  color: #ffffff;
  transition: 0.3s ease-in-out;
  text-decoration: none;
  border: none;
  -webkit-user-drag: none;
  user-select: none;
  cursor: pointer;
  padding: 0;
  font-family: inherit;
}

.social-link:hover {
  transform: scale(1.1) translateY(-1px);
  color: #fff;
  text-decoration: none;
  background: rgba(255,255,255,0.06);
}
</style>
